import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';

import { routes } from 'core/routing';
import styles from 'theme/components/project-breadcrumbs.module.scss';

export const PROJECT_BREADCRUMBS_PAGE = {
  inputs: 0,
  outputs: 1,
  dashboard: 2
};

const ProjectBreadcrumbs = ({ projectId, page }) => {
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      page: PROJECT_BREADCRUMBS_PAGE.inputs,
      label: 'Inputs',
      hrefBuilder: routes.projectInputs
    },
    {
      page: PROJECT_BREADCRUMBS_PAGE.outputs,
      label: 'Outputs',
      hrefBuilder: routes.projectOutputs
    },
    {
      page: PROJECT_BREADCRUMBS_PAGE.dashboard,
      label: 'Dashboard',
      hrefBuilder: routes.dashboard
    }
  ];

  return (
    <Breadcrumb className={styles.breadcrumbs}>
      {breadcrumbs.map((b) => {
        const href = b.hrefBuilder(projectId);

        const breadcrumbProps =
          page === b.page
            ? { isCurrentPage: true }
            : {
                href,
                onClick: (e) => {
                  e.preventDefault();
                  navigate(href);
                }
              };

        return (
          <BreadcrumbItem key={b.page} {...breadcrumbProps}>
            {b.label}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
};

export default memo(ProjectBreadcrumbs);
